// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"84806054","198":"3185a55e"}[chunkId] + ".chunk.js";
};